export default __webpack_public_path__ + "static/media/history1.366d3787.png";